import { Controller } from "@hotwired/stimulus";

const DISMISS_AFTER_MS = 5000;

export default class extends Controller {
  static values = {
    autoDismiss: { type: Boolean, default: true }
  }

  connect() {
    if (this.autoDismissValue) {
      this.timer = setTimeout(() => this.dismiss(), DISMISS_AFTER_MS);
    }
  }

  disconnect() {
    clearTimeout(this.timer);
  }

  dismiss() {
    this.element.remove();
  }
}
